import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';

export type CashbackSheet = 'cash-back' | 'active-credit' | null;

interface CashBackInfoSheetProps {
  type: CashbackSheet;
  open: boolean;
  onClose: () => void;
}

export const CASHBACK_EXPIRE_DAYS = 60;
export const CASHBACK_RETURN_DAYS = 180;

const sheetContent = {
  'cash-back': {
    title: 'اعتبار بازگشتی',
    description: (
      <div className="flex flex-col">
        <span>
          این اعتبار از زمان فعال‌سازی تا {CASHBACK_EXPIRE_DAYS} روز برای خرید
          از فروشگاه‌های مزرعه قابل استفاده است.
        </span>

        <span>
          پس از پایان {CASHBACK_RETURN_DAYS} روز، مبلغ اعتبار قابل نقد شدن است و
          در تاریخ انقضای اعتبار، وجه آن به کیف پول یا کارت بانکی شما
          بازمی‌گردد.
        </span>
      </div>
    ),
  },

  'active-credit': {
    title: 'اعتبار فعال',
    description: (
      <span>
        اعتباری که می‌توانید برای خرید از فروشگاه‌های سامانه مزرعه استفاده کنید.
        همچنین پس از گذشت {CASHBACK_EXPIRE_DAYS} روز، امکان درخواست برداشت وجه
        اعتبار را خواهید داشت.
      </span>
    ),
  },
} as const;

const CashBackInfoSheet = ({type, open, onClose}: CashBackInfoSheetProps) => {
  if (type === null) return null;

  const content = sheetContent[type];

  return (
    <BottomSheet
      open={open}
      onDismiss={onClose}
      blocking
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full p-6">
        <button
          type="button"
          aria-label="بستن"
          className="absolute outline-none left-6 top-6 ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none"
          onClick={onClose}
        >
          <i className="text-2xl text-gray-500 icon-nameClose-remove" />
        </button>

        <div className="flex flex-col items-center">
          <i className="mb-1 text-3xl icon-namereport text-farm-shop-600" />

          <h2 className="mb-0 text-lg font-medium text-gray-950">
            {content.title}
          </h2>
        </div>

        <div className="mt-3 text-sm text-gray-700">{content.description}</div>

        <div className="flex justify-end mt-3">
          <Button onClick={onClose}>متوجه شدم</Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CashBackInfoSheet;
